/*
 * Colour family swatches on product cards.
 * Tapping a colour previews it in place on the collection tile instead of
 * navigating away. The tile's image, title, price and links all switch to the
 * previewed colour, so tapping the card then opens the colour being viewed.
 * Without JS the swatches stay ordinary links to the other colour's page.
 */
(function () {
	if (window.__colourFamilyCardInit) { return; }
	window.__colourFamilyCardInit = true;

	function each(list, fn) {
		Array.prototype.slice.call(list).forEach(fn);
	}

	function preview(swatch) {
		var card = swatch.closest('.product-card');
		if (!card) { return; }

		var img = swatch.getAttribute('data-img');
		var href = swatch.getAttribute('data-href');
		var title = swatch.getAttribute('data-title');
		var price = swatch.getAttribute('data-price');
		var handle = swatch.getAttribute('data-handle');

		/* Main image. The <source> elements win over <img srcset>, so drop them
		   and let the img we control decide. */
		var picture = card.querySelector('.product-card__image-picture:not(.product-card__image-picture--hover)');

		if (picture && img) {
			picture.classList.remove('lazy');
			each(picture.querySelectorAll('source'), function (source) {
				source.parentNode.removeChild(source);
			});

			var el = picture.querySelector('img');

			if (el) {
				el.removeAttribute('sizes');
				el.setAttribute('src', img);
				el.setAttribute('srcset', img);
				el.setAttribute('data-src', img);
				el.setAttribute('data-srcset', img);
				if (title) { el.setAttribute('alt', title); }
			}
		}

		/* The hover image belongs to the original colour, so retire it. */
		var wrapper = card.querySelector('.product-card__image-wrapper');
		if (wrapper) { wrapper.classList.remove('product-card__image-wrapper--with-hover'); }

		var hover = card.querySelector('.product-card__image-picture--hover');
		if (hover) { hover.style.display = 'none'; }

		if (href) {
			each(card.querySelectorAll('a.product-card__image-wrapper-link, a.product-card__title'), function (link) {
				link.setAttribute('href', href);
			});
		}

		var titleEl = card.querySelector('.product-card__title');
		if (titleEl && title) {
			titleEl.textContent = title;
			titleEl.setAttribute('aria-label', title);
		}

		var priceEl = card.querySelector('.product-card__price');
		if (priceEl && price) { priceEl.innerHTML = price; }

		if (handle) {
			each(card.querySelectorAll('[data-product-card-handle]'), function (button) {
				button.setAttribute('data-product-card-handle', handle);
			});
		}

		each(card.querySelectorAll('.colour-family--card .colour-family__swatch'), function (other) {
			other.classList.remove('is-active');
			other.removeAttribute('aria-current');
		});

		swatch.classList.add('is-active');
		swatch.setAttribute('aria-current', 'true');
	}

	function onActivate(event) {
		if (!event.target || !event.target.closest) { return; }

		var swatch = event.target.closest('.colour-family--card .colour-family__swatch');
		if (!swatch) { return; }

		event.preventDefault();
		event.stopPropagation();
		preview(swatch);
	}

	document.addEventListener('click', onActivate, true);
})();
